/**
 * Handles CEX logic
 */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ApiList from './ApiList';
import ConnectExchange from './ConnectExchange';
import { getExchangeInfo } from '../../../../selectors/cex';

import './styles.scss';

const CEXWallet = () => {
  const { activeExchange, exchange } = useSelector(getExchangeInfo);

  const [connecting, setConnecting] = useState(false);

  if (activeExchange?.enable) {
    return <ApiList exchange={exchange} />;
  }

  if (connecting) {
    return (
      <ConnectExchange exchange={exchange} reset={() => setConnecting(false)} />
    );
  }

  return (
    <ApiList
      exchange={exchange}
      triggerConnecting={() => setConnecting(true)}
    />
  );
};

export default CEXWallet;
